import { render, staticRenderFns } from "./CmsProductLinksPopup.vue?vue&type=template&id=634effc4&scoped=true&"
import script from "./CmsProductLinksPopup.vue?vue&type=script&lang=js&"
export * from "./CmsProductLinksPopup.vue?vue&type=script&lang=js&"
import style0 from "./CmsProductLinksPopup.vue?vue&type=style&index=0&id=634effc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634effc4",
  null
  
)

export default component.exports